import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import * as api from '../../lib/api'

export default class PointPicker extends Component {
  state = {
    points: []
  }

  componentDidMount() {
    this.populatePoints()
  }

  componentDidUpdate(prevProps) {
    if (this.props.formContext.experienceUid !== prevProps.formContext.experienceUid) {
      this.populatePoints()
    }
  }

  populatePoints() {
    const { experienceUid } = this.props.formContext
    if (!experienceUid) return

    api.points.getFromExperience(experienceUid).then(points => {
      this.setState({ points })
    })
  }

  render() {
    const { points } = this.state
    const { experienceUid, siteUid, tracks: contextTracks } = this.props.formContext || {}
    const tracks = contextTracks || []
    const trackPoints = (points || [])
      .map(point => {
        return {
          point,
          track: tracks.find(({ _id }) => _id === point.trackId) || {
            name: '',
            type: ''
          }
        }
      })
      .sort((one, two) => {
        const labelOne = one.track.name + ' ' + (one.point.internalName || one.point.name || '')
        const labelTwo = two.track.name + ' ' + (two.point.internalName || two.point.name || '')
        return labelOne.localeCompare(labelTwo)
      })

    const currentPoint = points.find(p => p._id === this.props.formData)
    const button = currentPoint && (
      <Link
        to={`/site/${siteUid}/experience/${experienceUid}/track/${currentPoint.trackId}/point/${currentPoint._id}`}
        className="btn btn-default"
      >
        Voir
      </Link>
    )

    return (
      <div className="form-group field field-string">
        <label className="control-label" htmlFor={this.props.name}>
          {this.props.schema.title}
        </label>
        <div style={{ display: 'flex' }}>
          <select className="form-control" value={this.props.formData} onChange={e => this.props.onChange(e.target.value)}>
            <option />
            {trackPoints.map(({ track, point }) => {
              return (
                <option value={point._id} key={point._id}>
                  {track.name} - {point.internalName || point.name}{' '}
                </option>
              )
            })}
          </select>
          {button}
        </div>
      </div>
    )
  }
}
